<!-- DeleteActivityForm.vue -->
<script setup>
import { computed } from "vue";
import { useActivityStore } from "@/stores/useActivityStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  activity: {
    type: Object,
    required: true,
  },
});

// ✅ agora também emite notify, igual ao DeleteTextForm
const emit = defineEmits(["close", "refresh", "notify"]);
const store = useActivityStore();

// ✅ título da atividade vindo da store, com fallback na prop
const activityTitle = computed(() => {
  return (
    store.selectedActivity?.title ||
    store.selectedActivity?.Title ||
    props.activity?.title ||
    props.activity?.Title ||
    ""
  );
});

// ✅ mensagem da pergunta de confirmação com nome da atividade
const messageTitle = computed(() => {
  const title = activityTitle.value?.trim();
  if (!title) return "Tem certeza que deseja apagar esta atividade?";
  return `Tem certeza que deseja apagar a atividade "${title}"?`;
});

function buildDeleteActivityError(error) {
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir a atividade.";
  return raw;
}

async function onConfirmDelete() {
  try {
    await store.deleteActivityById(props.activity.activityId);

    // ✅ Toast genérico, sem nome da atividade
    emit("notify", {
      type: "success",
      message: "Atividade apagada com sucesso.",
    });

    // mantém comportamento original
    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildDeleteActivityError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    // mantém padrão do DeleteTextForm: throw para o modal parar o loading
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Atividade"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-la serão excluídas também todas as Notas vinculadas a ela. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
